export const RecordEmailFragment = gql`
  fragment RecordEmailFragment on RecordEmail {
    id
    sentAt
    subject
  }
`
